import AdminTraffic from '@/components/admin/AdminTraffic'
import ListAccount from '@/components/admin/account/ListAccount'
import ListProject from '@/components/admin/project/ListProject'
import EditProject from '@/components/admin/project/EditProject'
import ListTeam from '@/components/admin/team/ListTeam'
import ListCampaing from '@/components/admin/campaign/ListCampaign'
import ListTask from '@/components/admin/task/ListTask'
import TaskWithoutFinish from '@/components/admin/task/TaskWithoutFinish'
import EditTask from '@/components/admin/task/EditTask'
import ListProfile from '@/components/admin/profile/ListProfile'
import ListHour from '@/components/admin/hour/ListHour'
import ListEmail from '@/components/admin/email/ListEmail'
import EmailWithoutFinish from '@/components/admin/email/EmailWithoutFinish'
import EditMail from '@/components/admin/email/EditEmail'

export default {
  path: '/admin/traffic',
  //beforeEnter: requireAuth,
  name: 'AdminTraffic',
  component: AdminTraffic,
  children: [
    {
      path: 'accounts',
      component: ListAccount,
    },
    {
      path: 'projects',
      component: ListProject,
    },
    {
      path: 'project/:id',
      component: EditProject,
    },
    {
      path: 'teams',
      component: ListTeam,
    },
    {
      path: 'campaigns',
      component: ListCampaing,
    },
    {
      path: 'tasks',
      component: ListTask,
    },
    {
      path: 'tasks-without-finish',
      component: TaskWithoutFinish,
    },
    {
      path: 'task/:id',
      component: EditTask,
    },
    {
      path: 'emails',
      component: ListEmail,
    },
    {
      path: 'emails-without-finish',
      component: EmailWithoutFinish,
    },
    {
      path: 'email/:id',
      component: EditMail,
    },
    {
      path: 'profiles',
      component: ListProfile,
    },
    {
      path: 'hours',
      component: ListHour,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/admintraffic.js